import styled, { css } from 'styled-components';
import * as DataTableTypes from './DataTableTypes';

export const StyledSticky = styled.div`
  &[data-sticky-last-left-td],
  &[data-sticky-first-right-td] {
    &::before {
      content: '';
      height: 100%;
      top: 0;
      width: 30px;
      position: absolute;
    }
    color: ${({ theme }) => theme.colorOnSurface};
    background: ${({ theme }) => theme.colorSurface};
  }

  &[data-sticky-first-right-td]::before {
    left: -30px;
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.colorSurfaceFade0} 0%,
      ${({ theme }) => theme.colorSurfaceFade1} 60%,
      ${({ theme }) => theme.colorSurfaceFade1} 100%
    );
  }

  &[data-sticky-first-left-td]::before {
    right: -30px;
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.colorSurfaceFade1} 100%,
      ${({ theme }) => theme.colorSurfaceFade1} 60%,
      ${({ theme }) => theme.colorSurfaceFade0} 0%
    );
  }

  &[data-sticky-td] {
    width: 40px !important;
    padding: 0;
    flex: 40 0 auto !important;
    position: sticky !important;
  }
`;

export const StyledTd = styled(StyledSticky)<{
  $border?: DataTableTypes.DataTableBorder;
  $resizeTableColumns: boolean;
}>`
  align-items: center;
  display: flex;
  padding: ${({ $resizeTableColumns }) => ($resizeTableColumns ? '12px' : '12px 24px')};
  ${({ $border }) => ($border === 'none' ? noneBorderStyles : defaultBorderBottomStyles)};
`;

export const noneBorderStyles = css`
  border: none;
`;

export const defaultBorderStyles = css`
  border-bottom: 1px solid ${({ theme }) => theme.colorSurfaceVariant};
`;

export const defaultBorderBottomStyles = css`
  border-bottom: 1px solid ${({ theme }) => theme.colorSurfaceVariant};
`;
